import React from "react";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../store";
import LoginPage from "./login";
const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const { globalState, isLoading } = useSelector(
    (state: RootState) => state.auth
  );

  // Check if user is authenticated based on global state
  const isAuthenticated = globalState.access_token && globalState.subject_id;
  React.useEffect(() => {
    if (isAuthenticated && globalState.access_token) {
      const authChannel = new BroadcastChannel("auth-sync");

      authChannel.postMessage({
        type: "LOGIN",
        data: globalState,
      });

      // Cleanup
      return () => {
        authChannel.close();
      };
    }
  }, [globalState.access_token, isAuthenticated]);
  // Get user name from Redux global state instead of OIDC
  const userName =
    globalState.full_name ||
    `${globalState.first_name || ""} ${globalState.last_name || ""}`.trim() ||
    t("hub.dashboard.defaultUserName");
  // Show loading state if still loading
  if (isLoading && auth?.isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen  from-blue-50 to-indigo-100">
        <div className="text-center">
          {/* Loading text with animation */}
          <div className="space-y-2">
            <h2 className="text-2xl font-semibold text-gray-800 animate-pulse">
              {t("hub.dashboard.authenticating")}
            </h2>
            <p className="text-gray-600 animate-bounce">
              {t("hub.dashboard.verifyingCredentials")}
            </p>
          </div>

          {/* Progress dots */}
          <div className="flex justify-center space-x-2 mt-6">
            <div
              className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
              style={{ animationDelay: "0ms" }}
            ></div>
            <div
              className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
              style={{ animationDelay: "150ms" }}
            ></div>
            <div
              className="w-2 h-2 bg-blue-600 rounded-full animate-bounce"
              style={{ animationDelay: "300ms" }}
            ></div>
          </div>
        </div>
      </div>
    );
  }
  if (!isAuthenticated) {
    return <LoginPage />;
  }
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {t("hub.dashboard.title")}
        </h1>
        <p className="text-lg text-gray-600">
          {t("hub.dashboard.welcome", { name: userName })}
        </p>
      </div>
    </div>
  );
};

export default Dashboard;
